'use strict';

var _require = require('./Collapse'),
    Collapse = _require.Collapse;

var _require2 = require('./UnmountClosed'),
    UnmountClosed = _require2.UnmountClosed;

UnmountClosed.Collapse = Collapse;
UnmountClosed.UnmountClosed = UnmountClosed;

module.exports = UnmountClosed;


//////////////////
// WEBPACK FOOTER
// ./~/react-collapse/lib/index.js
// module id = 380
// module chunks = 95715928098905 168707334958949